export default "__VITE_ASSET__CR8reuTP__"